import { useQuery } from "@tanstack/react-query";
import { GET_MASTER_TABLE_DATA_QUERY_KEY } from "../types/CommonTypes";
import { fetcher } from "../../../utils/Axios";
import { GET_MASTER_TABLE_RESPONSE } from "../types/ResponseTypes";
import { API_DATA_LIMIT } from "../../../utils/Constants";

async function getMasterTableData(
  page: number,
  queryString: string
): Promise<GET_MASTER_TABLE_RESPONSE> {
  const { data } = await fetcher({
    url: `analytics/master-data?page=${page}&limit=${API_DATA_LIMIT}&${queryString}`,
  });

  return data;
}

const useGetMasterTableDataQuery = (
  page: number = 1,
  queryString: string = ""
) => {
  return useQuery({
    queryKey: [GET_MASTER_TABLE_DATA_QUERY_KEY, page, queryString],
    queryFn: () => getMasterTableData(page, queryString),
  });
};

export default useGetMasterTableDataQuery;
